module.exports = __webpack_public_path__ + "img/9.39e11a44.png";